<template>
 <div class="col-md-12">
  <ConsulteGrid
    :columns="rows"
    :data-source="dataSource"
    :actions="true"
    @on-change-data-row="rowChange"
  >
   <template #header>
    <router-link
      :to="{
        name: 'pattipobem_create',
        params: { patGrupoId: patGrupoId }
      }"
      class="btn btn-primary rounded-pill"
      style="margin-left: 10px;"
    >
     <i class="uil uil-plus" aria-hidden="true"></i>
     Cadastrar
    </router-link>
   </template>

   <template #botaoSelecionar="context">
    <button
      class="btn btn-outline-warning"
      @click="selecionarRegistro(context.row)"
      type="button"
    >
      Editar
    </button>
   </template>
  </ConsulteGrid>
 </div>
</template>

<script lang="ts">
import ConsulteGrid from "@/components/grid/ConsulteGrid.vue";
import { ConsulteGridColumnsModel } from "@/datasources/consulte-grid";
import { defineComponent } from "vue";
import PatTipoBemDataSource from "@/datasources/patrimonio/pattipobem/index.datasource";
import { PatTipoBemModel } from '@/models/patrimonio/pattipobem/pattipobem.model';

export default defineComponent({
  name: "PatTipoBemGridIndex",
  components: { ConsulteGrid },

  computed: {
    patGrupoId(): number {
      return Number(this.$route.params.patGrupoId || this.$route.params.id);
    }
  },

  methods: {
    rowChange(value: string, row: PatTipoBemModel) {
      console.log(value);
      console.log(row);
    },

    async selecionarRegistro(row: PatTipoBemModel) {
      await this.$router.push({
        name: 'pattipobem_create',
        params: {
          patGrupoId: row.patGrupoId,
          id: row.patTipoBemId
        }
      });
    },
  },

  data() {
    return {
      dataSource: new PatTipoBemDataSource(0, 10, 0, 0, []),
      rows: [
        {
          text: "Selecionar",
          align: "center",
          cellsalign: "center",
          datafield: "botaoSelecionar",
          editable: false,
          filtertype: "text",
          filterable: false
        },
        {
          text: "Ordem",
          align: "center",
          cellsalign: "center",
          datafield: "ordem",
          editable: false,
          filtertype: "text",
          filterable: false
        },
        {
          text: "Código",
          align: "center",
          cellsalign: "center",
          datafield: "codigo",
          editable: false,
          filtertype: "text",
          filterable: true
        },
        {
          text: "Descricao",
          align: "center",
          cellsalign: "center",
          datafield: "descricao",
          editable: false,
          filtertype: "text",
          filterable: true
        },
      ] as ConsulteGridColumnsModel[],
    };
  }
});
</script>
